// axios
import axios from 'axios'

const domain = ''

export default axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL + 'graphql',
  domain
  // You can add your headers here
})
